<template>
  <div class="mt-5">
    <h4 class="card-title">{{ title }}</h4>

    <div class="timeline-container">
      <template v-for="(val, key, index) in events" class="">
        <div class="event-box" :class="{'event-box-bottom' : key % 2 !== 0}" :key="`eventBox${key}${index}`">

          <div class="event-data" :class="{'event-data-bottom' : key % 2 !== 0}" :style="{'background-color': getEventColor(val.type)}">
            <div class="event-symbol">{{ val.symbol }}</div>
            <div class="triangle" :style="{'background-color': getEventColor(val.type)}"></div> <!-- because we have to change the color, another solution: https://forum.vuejs.org/t/style-binding-on-pseudo-selector/5544/8 -->
          </div>

          <div class="event-date" :class="{'event-date-bottom' : key % 2 !== 0}">
            {{val.date}}
          </div>
        </div>
      </template>
    </div>

    <b-button class="float-right mt-3" @click="expandTable = !expandTable" variant="outline-secondary">{{ $t('message.Guideline.Milestones.toggleTableView') }}</b-button>

    <b-table v-if="expandTable" :items="months" :fields="fields">
      <template slot="table-colgroup">
        <col width="90px">
        <col>
        <col>
      </template>

      <template slot="month" slot-scope="data">
        {{ data.item.month }}
      </template>
      <template slot="symbol" slot-scope="data">
        <b-table fixed hover :items="data.item.events" :fields="sub_fields"></b-table>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'milestones',
  components: {},
  props: {
    title: {
      type: String,
      required: true
    },
    createdDate: {
      type: String,
      required: true
    },
    dates: {
      /**
       * Timeline with gchart
       * @type {Array}
       */
      type: Array,
      default: () => null,
      required: false,
    },
    budgets: {
      type: Array
    },
  },
  data () {
    return {
      fields: [
        {
          key: 'month',
          // label: 'Person age',
        },
        {
          key: 'symbol',
          label: '',
        }
      ],

      sub_fields: [
        {
          key: 'symbol',
          label: 'Item',
        },
        {
          key: 'date',
          label: false,
        },
        {
          key: 'title',
          label: false,
        }
      ],
      expandTable: false,
    }
  },
  computed: {
    months() {
      return this.getMilestoneMonths();
    },

    events() {
      let events = this.getMilestoneMonths().flatMap(x => x.events ? x.events : null);
      events.sort((a,b)=> { return this.moment(a.date, 'DD-MM-YYYY').isBefore( this.moment(b.date, 'DD-MM-YYYY')) ? -1 : 1 });
      return events;
    },

    label() {
      return this.moment(this.dates_internal[0].date, 'DD-MM-YYYY').format('YYYY');
    },

    // /**
    //    * Timeline with gchart defaults, override this props dates
    //    * @type {Array}
    //    */
    dates_internal() { 
      return this.dates ? this.dates : [
        { symbol: this.$t('message.Guideline.phase10'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').format('DD-MM-YYYY'), title: 'Entry submitted' },
        { symbol: this.$t('message.Guideline.phase40'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(3, 'weeks').format('DD-MM-YYYY'), title: 'Pre-approved entry' },
        { symbol: this.$t('message.Guideline.Milestones.M3'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(6, 'weeks').format('DD-MM-YYYY'), title: 'Involved parties defined' },
        { symbol: this.$t('message.Guideline.Milestones.M4'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(6, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline draft uploaded' },
        { symbol: this.$t('message.Guideline.Milestones.M4_2'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(8, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'GPC Review round #1 finished' },
        { symbol: this.$t('message.Guideline.Milestones.M4_4'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(10, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Edited version of Guideline uploaded' },
        { symbol: this.$t('message.Guideline.Milestones.M5'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(13, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Review round #1 finished' },
        { symbol: this.$t('message.Guideline.Milestones.M6'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(16, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Edited version of Guideline uploaded' },
        { symbol: this.$t('message.Guideline.Milestones.M7'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(19, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Edited version approved (=review round #2)' },
        { symbol: this.$t('message.Guideline.Milestones.M8'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(22, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline for National Delegate review uploaded' },
        { symbol: this.$t('message.Guideline.Milestones.M9'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(25, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline approved' },
        { symbol: this.$t('message.Guideline.Milestones.M10'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(28, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Final manuscript uploaded' },
        { symbol: this.$t('message.Guideline.Milestones.M11'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(31, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline finally approved' },
        { symbol: this.$t('message.Guideline.Milestones.M12'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(31, 'weeks').add(12, 'months').format('DD-MM-YYYY'), title: 'Guideline published' },

        /* Milestone changed to phases
           need to be adjusted at the end when all phases are available
        { symbol: this.$t('message.Guideline.phase50'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(6, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline draft uploaded' },
        { symbol: this.$t('message.Guideline.phase60'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(9, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Review round #1 finished' },
        { symbol: this.$t('message.Guideline.phase50'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(12, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Edited version of Guideline uploaded' },
        { symbol: this.$t('message.Guideline.phase70'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(15, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Edited version approved (=review round #2)' },
        { symbol: this.$t('message.Guideline.phase80'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(18, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline for National Delegate review uploaded' },
        { symbol: this.$t('message.Guideline.phase100'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(21, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline approved' },
        { symbol: this.$t('message.Guideline.phase110'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(24, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Final manuscript uploaded' },
        { symbol: this.$t('message.Guideline.phase120'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(27, 'weeks').add(6, 'months').format('DD-MM-YYYY'), title: 'Guideline finally approved' },
        { symbol: this.$t('message.Guideline.phase140'), date: this.moment(this.createdDate, 'DD-MM-YYYY HH:mm:ss').add(27, 'weeks').add(12, 'months').format('DD-MM-YYYY'), title: 'Guideline published' },
      */
      ];
    }
  },
  mounted () {
  },
  methods: {

    getMilestoneMonths() {
      let months = [];

      for (let x in this.dates_internal) {
        let month = this.moment(this.dates_internal[x].date, 'DD-MM-YYYY').format('YYYY-MM');
        let cm = months.filter( elem => { return elem.month == month });

        /**
         * Percentage parts of month [ppom]
         */
        this.dates_internal[x].ppom = Math.round(this.moment(this.dates_internal[x].date, 'DD-MM-YYYY').format('D') / 30 * 100);

        if (cm.length > 0) {
          cm[0].events.push(this.dates_internal[x])
        } else {
          months.push(
              {
                month: month,
                events: [ this.dates_internal[x] ]
              }
          );
        }
      }

      /**
       * Handle budgets
       */
      for (let x in this.budgets) {
        let month = this.moment(this.budgets[x].start, 'YYYY-MM-DD').format('YYYY-MM');

        let event = {
          symbol: this.budgets[x].title,
          date: this.moment(this.budgets[x].start, 'YYYY-MM-DD').format('DD-MM-YYYY'),
          title: this.budgets[x].title,
          type: this.budgets[x].type,
        };

        let cm = months.filter( elem => { return elem.month == month });

        if (cm.length > 0) {
          cm[0].events.push(event)
        } else {
          months.push(
              {
                month: month,
                events: [ event ]
              }
          );
        }
      }

      /**
       * Sort each events.
       */
      for(let x in months) {
        months[x].events.sort((a,b)=> { return this.moment(a.date, 'DD-MM-YYYY').isBefore( this.moment(b.date, 'DD-MM-YYYY')) ? -1 : 1 });
      }

      months.sort((a, b) => {
        return this.moment(a.month, 'MM').diff(this.moment(b.month, 'MM'), 'days');
      });

      return months;
    },

    getEventColor(eventType) {

      switch (eventType) {
        case 'meeting':
          return '#137eff';
        case 'medical':
          return '#5bc146';
        case 'meta':
          return '#7e8d9a';
        case 'publication':
          return '#fe4d62';

        default:
          return '#1dc9b7'
      }
    },

    getPointStyle(index, row) {
      let offset = row.ppom + (index*5);
      let color = '#c15247';

      switch (row.type) {
        case 'meeting':
          color = '#137eff';
          break
        case 'medical':
          color = '#5bc146';
          break
        case 'meta':
          color = '#7e8d9a';
          break
        case 'publication':
          color = '#fe4d62';
          break
      }

      if (offset > 90) {
        offset = 90;
      }

      if (index%2) {
        return `color: ${color}; bottom: -15px; left: ${offset}%`;
      } else {
        return `color: ${color}; top: -15px; left: ${offset}%`;
      }
    },

    getId(key, index) {
      return 'milestone' + String(key) + String(index);
    },

    getPlacementId(key, index) {
      if (index == 0) {
        return 'top';
      } else {
        return (index%2 == 1)?'bottom':'top';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.milestones {
  width: 100%;
  color: white;
  font-weight: bold;
  padding: 2px;
  height: 58px;

  .bggrad {
    background-image: linear-gradient(#415262, #adb4be);
    border-right: 1px solid white;
  }
}

.bggrad2 {
  margin-top: 5px;
  margin-left: 50px;
  height: 20px;
  background-image: linear-gradient(#c1c5ce, #f4f4f6);
  border-right: 1px solid white;
}

.label{
  color: #c15247;
  font-weight: 700;
}

.timeline-container {

  position: relative;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  height: 450px;
  border: 1px solid transparent;
}


::-webkit-scrollbar {
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ababab;
  border-radius: 6px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.event-date {
  position: absolute;
  left:3px;
  bottom: -30px;
  color: #666666;
  font-size: 0.8rem;
  font-weight: bold;
}

.event-date-bottom {
  top: -30px;
}

.event-symbol {

  font-weight: bold;
}

.event-title {
  white-space: normal;
  text-align: left;
  color: #ffffff;
}

.event-data {
  padding: 10px;
  border-radius: 6px;
  background-color: #1dc9b7;
  position: absolute;
  bottom: 35px;
  z-index: 1000;

  .triangle {
    width: 12px;
    height: 12px;
    background-color: #1dc9b7;
    transform: rotate(45deg);
    position: absolute;
    bottom: -6px;
    left: 23px;
    z-index: -1;
  }
}

.event-data-bottom {
  top: 35px;
  bottom: unset;

  .triangle {
    top: -6px;
  }
}

.event-box {
  position: relative;
  height: 200px;
  padding: 0 10px;
  width: 200px;
  display: inline-block;
  //background-color: red;
  vertical-align: top;

  top: 0;
  border-bottom: 3px solid #2C3E50;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    left: 30px;
    bottom: -11px;
    width: 20px;
    height: 20px;
    background-color: #2C3E50;
    border: 3px solid #ffffff;
    border-radius: 50%;
    z-index: 0;
  }

}
.event-box-bottom {
  top: 197px;
  border-top: 3px solid #2C3E50;
  border-bottom: none;

  &::after {
    content: '';
    position: absolute;
    left: 30px;
    top: -11px;
    width: 20px;
    height: 20px;
    background-color: #2C3E50;
    border: 3px solid #ffffff;
    border-radius: 50%;
  }
}
</style>

